import type { CaseItem } from '@/mocks/cases';

export default function Timeline({ items }: { items: CaseItem['timeline'] }) {
  return (
    <ol className="relative border-l border-background-300 pl-6">
      {items.map((node) => (
        <li key={node.date + node.title} className="relative pb-6 last:pb-0">
          <span className="absolute -left-[7px] top-1 h-3 w-3 rounded-full bg-accent-500"></span>
          <time className="text-xs font-medium text-foreground-500">{node.date}</time>
          <h3 className="mt-1 font-heading text-base font-semibold text-foreground-950">{node.title}</h3>
          <p className="mt-1 text-sm leading-relaxed text-foreground-600">{node.desc}</p>
        </li>
      ))}
    </ol>
  );
}